import { Component } from 'react';
import Map from 'google-map-react';

class MyPlace extends Component {
    constructor(props) {
      super(props);
    }
    
    render() {
      return (
        <img src="/static/images/map-marker.png" alt={this.props.message} />
      );
    }
  }

class MyMap extends Component {
    static defaultProps = {
        center: {
          lat: 51.0204104,
          lng: 4.4794394
        },
        zoom: 17
      };  
  
    render() {
        return (
            <div className="map-area">
                <Map
                  bootstrapURLKeys={{ key: "AIzaSyCaWmb4QhbibDT2pdf4DuxMChLUWLwtBdo" }}
                  center={this.props.center}
                  zoom={this.props.zoom}>
                  <MyPlace 
                    lat={51.0204104} 
                    lng={4.4794394} 
                    message={this.props.message} 
                  />
                </Map>
            </div>
        );
    }
}

export default MyMap